<script setup lang="ts">
const props = withDefaults(defineProps<{
    maxWidth?: number;
}>(), {
    maxWidth: 400
});
</script>

<template>
    <div class="tooltip-container" role="tooltip">
        <span class="tooltip-content" :style="{ maxWidth: props.maxWidth + 'px' }">
            <slot />
        </span>
    </div>
</template>

<style lang="scss" scoped>
@import '@Common/Styles/variables';

.tooltip-container {
    z-index: 10;
    position: absolute;
    left: 0px;
    font-family: var(--font, Mulish, sans-serif);

    .tooltip-content {
        display: block;
        width: max-content;
        background-color: map-get($yapla-gray, 800);
        line-height: 20px;
        opacity: 0.9;
        color: map-get($yapla-gray, 100);
        box-shadow: 0 5px 15px rgba(0, 87, 255, 0.1);
        border-radius: 6px;
        padding: 5px 8px;
        font-weight: 500;
        font-size: 15px;
        hyphens: auto;
        word-wrap: break-word;
        text-align: justify;
    }
}
</style>